import { Reducer } from "redux";
import { ProductActionTypes, ProductState } from "./types";

export const initialState: ProductState = {
  products: [],
  product: [],
  similarProducts: [],
  newProducts: [],
  viewedProducts: [],
  categories: [],
  categoryList: [],
  searchResults: [],
  crossGroups: [],
  crossProductsByGroup: {},
  errors: undefined,
  loading: false,
  loadingId: false,
  newLoading: false,
  viewedLoading: false,
  similarLoading: false,
  categoriesLoading: false,
  categoryListLoading: false,
  crossGroupsLoading: false,
  crossProductsLoading: false
};

const toArray = <T,>(payload: T | T[] | undefined | null): T[] => {
  if (!payload) return [];
  return Array.isArray(payload) ? payload : [payload];
};

const toProducts = (payload: any) => toArray(payload).filter((item: any) => item?.code && item?.title);

const reducer: Reducer<ProductState> = (state = initialState, action) => {
  console.log(action)
  switch (action.type) {
    case ProductActionTypes.FETCH_SIMILAR_REQUEST: {
      return { ...state, similarLoading: true };
    }
    case ProductActionTypes.FETCH_NEW_REQUEST: {
      return { ...state, newLoading: true };
    }
    case ProductActionTypes.FETCH_VIEWED_REQUEST: {
      return { ...state, viewedLoading: true };
    }
    case ProductActionTypes.FETCH_REQUEST: {
      return { ...state, loading: true };
    }
    case ProductActionTypes.FETCH_LIST_REQUEST: {
      return { ...state, categoryListLoading: true };
    }
    case ProductActionTypes.FETCH_CATEGORY_REQUEST: {
      return { ...state, categoriesLoading: true };
    }
    case ProductActionTypes.FETCH_CROSS_GROUPS_REQUEST: {
      return { ...state, crossGroupsLoading: true, crossGroups: [], crossProductsByGroup: {} };
    }
    case ProductActionTypes.FETCH_CROSS_PRODUCTS_REQUEST: {
      return { ...state, crossProductsLoading: true };
    }
    case ProductActionTypes.SEARCH_REQUEST: {
      return { ...state, searchResults: [] };
    }
    case ProductActionTypes.FETCH_SIMILAR_SUCCESS: {
      return { ...state, similarLoading: false, similarProducts: toProducts(action.payload) };
    }
    case ProductActionTypes.FETCH_CATEGORY_SUCCESS: {
      return { ...state, categoriesLoading: false, categories: toArray(action.payload) };
    }
    case ProductActionTypes.FETCH_LIST_SUCCESS: {
      return { ...state, categoryListLoading: false, categoryList: toArray(action.payload) };
    }
    case ProductActionTypes.FETCH_CROSS_GROUPS_SUCCESS: {
      return { ...state, crossGroupsLoading: false, crossGroups: toArray(action.payload) };
    }
    case ProductActionTypes.FETCH_CROSS_PRODUCTS_SUCCESS: {
      return {
        ...state,
        crossProductsLoading: false,
        crossProductsByGroup: {
          ...state.crossProductsByGroup,
          [action.groupCode]: toProducts(action.payload),
        },
      };
    }
    case ProductActionTypes.FETCH_NEW_SUCCESS: {
      return { ...state, newLoading: false, newProducts: toProducts(action.payload) };
    }
    case ProductActionTypes.FETCH_VIEWED_SUCCESS: {
      return { ...state, viewedLoading: false, viewedProducts: toProducts(action.payload) };
    }
    case ProductActionTypes.FETCH_SUCCESS: {
      return { ...state, loading: false, products: toProducts(action.payload) };
    }
    case ProductActionTypes.FETCH_ID_REQUEST: {
      return { ...state, loadingId: true };
    }
    case ProductActionTypes.FETCH_ID_SUCCESS: {
      return { ...state, loadingId: false, product: toProducts(action.payload) };
    }
    case ProductActionTypes.FETCH_ERROR: {
      return { ...state, loading: false, loadingId: false, crossGroupsLoading: false, crossProductsLoading: false, errors: action.payload };
    }
    case ProductActionTypes.SEARCH_SUCCESS: {
      return { ...state, newLoading: false, searchResults: toProducts(action.payload) };
    }
    default: {
      return state;
    }
  }
};

export { reducer as ProductsReducer };
